var $class="se2--content-article-slide-carousel-background--slide",$name="ContentArticleSlideCarouselBackground/slide",$path="app/components/ContentArticleSlideCarouselBackground/partials/slide/index.js",$this={$class,$name,$path,};const contentArticleSlideCarouselBackgroundSlideSelector = `.${$class}`;

export default contentArticleSlideCarouselBackgroundSlideSelector;
